export class MaintenanceStrategyImportModel {
  counter: number = 0;
  companyId: number = 0;
  articleCode: number = 0;
  interval: number = 0;
  maintenancePlan: number = 0;
  constructor(
    counter: number,
    companyId: number,
    articleCode: number,
    interval: number,
    maintenancePlan: number
  ) {
    this.counter = counter;
    this.companyId = companyId;
    this.articleCode = articleCode;
    this.interval = interval;
    this.maintenancePlan = maintenancePlan;
  }
}